import { createPortal } from 'react-dom'
import Select from 'react-select'
import { Modal } from 'react-bootstrap'
import { KTSVG } from '_metronic/helpers'
import { SURVEY_STATUS_OPTIONS } from 'Configuration/Paco'

interface Props {
  open: boolean
  value: any
  onChange: (value: any) => void
  handleClose: () => void
  handleSubmit: () => void
}

const JobStatusChanger: React.FC<Props> = ({
  open,
  handleClose,
  handleSubmit,
  value,
  onChange,
}) => {
  const modalsRoot = document.getElementById('root-modals') || document.body

  const statusOptions = SURVEY_STATUS_OPTIONS.map(item => ({
    label: `${item.key.substring(0, 1).toUpperCase()}${item.key.substring(1).toLowerCase()} - ${
      item.title
    }`,
    value: item.key,
  }))

  return createPortal(
    <Modal
      id='kt_modal_sale_order_import'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered modal-dialog-scrollable mw-900px'
      show={open}
      onHide={handleClose}
      backdrop={true}>
      <div className='modal-content'>
        <div className='modal-header'>
          <h2>เปลี่ยนแปลงสถานะงาน</h2>
          {/* begin::Close */}
          <div className='btn btn-sm btn-icon btn-active-light-danger' onClick={handleClose}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/general/gen040.svg' />
          </div>
          {/* end::Close */}
        </div>

        <div className='modal-body py-lg-10 px-lg-10 min-h-200px'>
          <Select
            isClearable={false}
            isMulti={false}
            options={statusOptions}
            value={statusOptions.find(item => item.value === value) ?? null}
            onChange={(item: any) => onChange(item?.value)}
          />
        </div>

        <div className='modal-footer'>
          <button type='button' className='btn btn-sm btn-light' onClick={handleClose}>
            ยกเลิก
          </button>
          <button type='button' className='btn btn-sm btn-primary' onClick={handleSubmit}>
            บันทึก
          </button>
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export default JobStatusChanger
